"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _CognitoClaimsImpl_ec, _CognitoBuilder_claims;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CognitoBuilder = exports.CognitoClaimNames = exports.cognitoClaimNames = void 0;
exports.FromCognitoWireClaims = FromCognitoWireClaims;
exports.DefaultCognitoClaims = DefaultCognitoClaims;
exports.TestCognitoClaims = TestCognitoClaims;
const claims_1 = require("./claims");
class cognitoClaimNames {
    constructor() {
        this.EMAIL = 'email';
        this.PHONE_NUMBER = 'phone_number';
        this.USERNAME = 'cognito:username';
        this.EVENT_ID = 'event_id';
        this.EMAIL_VERIFIED = 'email_verified';
        this.PHONE_NUMBER_VERIFIED = 'phone_number_verified';
        this.TOKEN_USE = 'token_use';
        this.ADDRESS = 'address';
        this.BIRTHDATE = 'birthdate';
        this.FAMILY_NAME = 'family_name';
        this.GENDER = 'gender';
        this.GIVEN_NAME = 'given_name';
        this.LOCALE = 'locale';
        this.MIDDLE_NAME = 'middle_name';
        this.NAME = 'name';
        this.NICKNAME = 'nickname';
        this.PICTURE = 'picture';
        this.PREFERRED_USERNAME = 'preferred_username';
        this.PROFILE = 'profile';
        this.UPDATED_AT = 'updated_at';
        this.WEBSITE = 'website';
        this.ZONEINFO = 'zoneinfo';
        this.EMAIL_ALIAS = 'cognito:email_alias';
        this.USER_STATUS = 'cognito:user_status';
        this.PHONE_NUMBER_ALIAS = 'cognito:phone_number_alias';
    }
}
exports.cognitoClaimNames = cognitoClaimNames;
exports.CognitoClaimNames = new cognitoClaimNames();
function ToCognitoWireClaims(claims) {
    const ret = {};
    if ((0, claims_1.isSome)(claims.email)) {
        ret.email = (0, claims_1.toString)(claims.email);
    }
    if ((0, claims_1.isSome)(claims.phoneNumber)) {
        ret.phone_number = (0, claims_1.toString)(claims.phoneNumber);
    }
    if ((0, claims_1.isSome)(claims.username)) {
        ret[exports.CognitoClaimNames.USERNAME] = (0, claims_1.toString)(claims.username);
    }
    if ((0, claims_1.isSome)(claims.eventId)) {
        ret.event_id = (0, claims_1.toString)(claims.eventId);
    }
    if ((0, claims_1.isSome)(claims.isEmailVerified)) {
        ret.email_verified = (0, claims_1.toBoolean)(claims.isEmailVerified);
    }
    if ((0, claims_1.isSome)(claims.isPhoneNumberVerified)) {
        ret.phone_number_verified = (0, claims_1.toBoolean)(claims.isPhoneNumberVerified);
    }
    if ((0, claims_1.isSome)(claims.tokenUse)) {
        ret.token_use = (0, claims_1.toString)(claims.tokenUse);
    }
    if ((0, claims_1.isSome)(claims.address)) {
        ret.address = (0, claims_1.toString)(claims.address);
    }
    if ((0, claims_1.isSome)(claims.birthdate)) {
        ret.birthdate = (0, claims_1.toString)(claims.birthdate);
    }
    if ((0, claims_1.isSome)(claims.familyName)) {
        ret.family_name = (0, claims_1.toString)(claims.familyName);
    }
    if ((0, claims_1.isSome)(claims.gender)) {
        ret.gender = (0, claims_1.toString)(claims.gender);
    }
    if ((0, claims_1.isSome)(claims.givenName)) {
        ret.given_name = (0, claims_1.toString)(claims.givenName);
    }
    if ((0, claims_1.isSome)(claims.locale)) {
        ret.locale = (0, claims_1.toString)(claims.locale);
    }
    if ((0, claims_1.isSome)(claims.middleName)) {
        ret.middle_name = (0, claims_1.toString)(claims.middleName);
    }
    if ((0, claims_1.isSome)(claims.name)) {
        ret.name = (0, claims_1.toString)(claims.name);
    }
    if ((0, claims_1.isSome)(claims.nickname)) {
        ret.nickname = (0, claims_1.toString)(claims.nickname);
    }
    if ((0, claims_1.isSome)(claims.picture)) {
        ret.picture = (0, claims_1.toString)(claims.picture);
    }
    if ((0, claims_1.isSome)(claims.preferredUsername)) {
        ret.preferred_username = (0, claims_1.toString)(claims.preferredUsername);
    }
    if ((0, claims_1.isSome)(claims.profile)) {
        ret.profile = (0, claims_1.toString)(claims.profile);
    }
    if ((0, claims_1.isSome)(claims.updatedAt)) {
        ret.updated_at = (0, claims_1.toString)(claims.updatedAt);
    }
    if ((0, claims_1.isSome)(claims.website)) {
        ret.website = (0, claims_1.toString)(claims.website);
    }
    if ((0, claims_1.isSome)(claims.zoneinfo)) {
        ret.zoneinfo = (0, claims_1.toString)(claims.zoneinfo);
    }
    if ((0, claims_1.isSome)(claims.emailAlias)) {
        ret[exports.CognitoClaimNames.EMAIL_ALIAS] = (0, claims_1.toString)(claims.emailAlias);
    }
    if ((0, claims_1.isSome)(claims.userStatus)) {
        ret[exports.CognitoClaimNames.USER_STATUS] = (0, claims_1.toString)(claims.userStatus);
    }
    if ((0, claims_1.isSome)(claims.phoneNumberAlias)) {
        ret[exports.CognitoClaimNames.PHONE_NUMBER_ALIAS] = (0, claims_1.toString)(claims.phoneNumberAlias);
    }
    return ret;
}
function toEntity(x) {
    return {
        email: claims_1.WithDefault.from(x.email, ''),
        phoneNumber: claims_1.WithDefault.from(x.phoneNumber, ''),
        username: claims_1.WithDefault.from(x.username, ''),
        eventId: claims_1.WithDefault.from(x.eventId, ''),
        isEmailVerified: claims_1.WithDefault.from(x.isEmailVerified, false),
        isPhoneNumberVerified: claims_1.WithDefault.from(x.isPhoneNumberVerified, false),
        tokenUse: claims_1.WithDefault.from(x.tokenUse, ''),
        address: claims_1.WithDefault.from(x.address, ''),
        birthdate: claims_1.WithDefault.from(x.birthdate, ''),
        familyName: claims_1.WithDefault.from(x.familyName, ''),
        gender: claims_1.WithDefault.from(x.gender, ''),
        givenName: claims_1.WithDefault.from(x.givenName, ''),
        locale: claims_1.WithDefault.from(x.locale, ''),
        middleName: claims_1.WithDefault.from(x.middleName, ''),
        name: claims_1.WithDefault.from(x.name, ''),
        nickname: claims_1.WithDefault.from(x.nickname, ''),
        picture: claims_1.WithDefault.from(x.picture, ''),
        preferredUsername: claims_1.WithDefault.from(x.preferredUsername, ''),
        profile: claims_1.WithDefault.from(x.profile, ''),
        updatedAt: claims_1.WithDefault.from(x.updatedAt, ''),
        website: claims_1.WithDefault.from(x.website, ''),
        zoneinfo: claims_1.WithDefault.from(x.zoneinfo, ''),
        emailAlias: claims_1.WithDefault.from(x.emailAlias, ''),
        userStatus: claims_1.WithDefault.from(x.userStatus, ''),
        phoneNumberAlias: claims_1.WithDefault.from(x.phoneNumberAlias, ''),
    };
}
function FromCognitoWireClaims(claims, defaults = {}) {
    const withDefaults = {
        ...ToCognitoWireClaims(toEntity(defaults)),
        ...claims,
    };
    const ec = new claims_1.ErrorCollector('cognito');
    return new CognitoClaimsImpl(ec, {
        email: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.EMAIL, '', ec),
        phoneNumber: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.PHONE_NUMBER, '', ec),
        username: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.USERNAME, '', ec),
        eventId: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.EVENT_ID, '', ec),
        isEmailVerified: (0, claims_1.requiredBooleanAttribute)(withDefaults, exports.CognitoClaimNames.EMAIL_VERIFIED, false, ec),
        isPhoneNumberVerified: (0, claims_1.requiredBooleanAttribute)(withDefaults, exports.CognitoClaimNames.PHONE_NUMBER_VERIFIED, false, ec),
        tokenUse: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.TOKEN_USE, '', ec),
        address: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.ADDRESS, '', ec),
        birthdate: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.BIRTHDATE, '', ec),
        familyName: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.FAMILY_NAME, '', ec),
        gender: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.GENDER, '', ec),
        givenName: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.GIVEN_NAME, '', ec),
        locale: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.LOCALE, '', ec),
        middleName: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.MIDDLE_NAME, '', ec),
        name: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.NAME, '', ec),
        nickname: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.NICKNAME, '', ec),
        picture: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.PICTURE, '', ec),
        preferredUsername: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.PREFERRED_USERNAME, '', ec),
        profile: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.PROFILE, '', ec),
        updatedAt: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.UPDATED_AT, '', ec),
        website: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.WEBSITE, '', ec),
        zoneinfo: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.ZONEINFO, '', ec),
        emailAlias: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.EMAIL_ALIAS, '', ec),
        userStatus: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.USER_STATUS, '', ec),
        phoneNumberAlias: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CognitoClaimNames.PHONE_NUMBER_ALIAS, '', ec),
    });
}
class CognitoClaimsImpl {
    constructor(ec, params) {
        _CognitoClaimsImpl_ec.set(this, void 0);
        this.email = () => {
            return this.defaulted.email.val;
        };
        this.phoneNumber = () => {
            return this.defaulted.phoneNumber.val;
        };
        this.username = () => {
            return this.defaulted.username.val;
        };
        this.eventId = () => {
            return this.defaulted.eventId.val;
        };
        this.isEmailVerified = () => {
            return this.defaulted.isEmailVerified.val;
        };
        this.isPhoneNumberVerified = () => {
            return this.defaulted.isPhoneNumberVerified.val;
        };
        this.tokenUse = () => {
            return this.defaulted.tokenUse.val;
        };
        this.address = () => {
            return this.defaulted.address.val;
        };
        this.birthdate = () => {
            return this.defaulted.birthdate.val;
        };
        this.familyName = () => {
            return this.defaulted.familyName.val;
        };
        this.gender = () => {
            return this.defaulted.gender.val;
        };
        this.givenName = () => {
            return this.defaulted.givenName.val;
        };
        this.locale = () => {
            return this.defaulted.locale.val;
        };
        this.middleName = () => {
            return this.defaulted.middleName.val;
        };
        this.name = () => {
            return this.defaulted.name.val;
        };
        this.nickname = () => {
            return this.defaulted.nickname.val;
        };
        this.picture = () => {
            return this.defaulted.picture.val;
        };
        this.preferredUsername = () => {
            return this.defaulted.preferredUsername.val;
        };
        this.profile = () => {
            return this.defaulted.profile.val;
        };
        this.updatedAt = () => {
            return this.defaulted.updatedAt.val;
        };
        this.website = () => {
            return this.defaulted.website.val;
        };
        this.zoneinfo = () => {
            return this.defaulted.zoneinfo.val;
        };
        this.emailAlias = () => {
            return this.defaulted.emailAlias.val;
        };
        this.userStatus = () => {
            return this.defaulted.userStatus.val;
        };
        this.phoneNumberAlias = () => {
            return this.defaulted.phoneNumberAlias.val;
        };
        this.defaulted = params;
        __classPrivateFieldSet(this, _CognitoClaimsImpl_ec, ec, "f");
    }
    wireEmail() {
        return (0, claims_1.isSome)(this.defaulted.email) ? this.email() : undefined;
    }
    wirePhoneNumber() {
        return (0, claims_1.isSome)(this.defaulted.phoneNumber) ? this.phoneNumber() : undefined;
    }
    wireUsername() {
        return (0, claims_1.isSome)(this.defaulted.username) ? this.username() : undefined;
    }
    wireEventId() {
        return (0, claims_1.isSome)(this.defaulted.eventId) ? this.eventId() : undefined;
    }
    wireIsEmailVerified() {
        return (0, claims_1.isSome)(this.defaulted.isEmailVerified)
            ? this.isEmailVerified()
            : undefined;
    }
    wireIsPhoneNumberVerified() {
        return (0, claims_1.isSome)(this.defaulted.isPhoneNumberVerified)
            ? this.isPhoneNumberVerified()
            : undefined;
    }
    wireTokenUse() {
        return (0, claims_1.isSome)(this.defaulted.tokenUse) ? this.tokenUse() : undefined;
    }
    wireAddress() {
        return (0, claims_1.isSome)(this.defaulted.address) ? this.address() : undefined;
    }
    wireBirthdate() {
        return (0, claims_1.isSome)(this.defaulted.birthdate) ? this.birthdate() : undefined;
    }
    wireFamilyName() {
        return (0, claims_1.isSome)(this.defaulted.familyName) ? this.familyName() : undefined;
    }
    wireGender() {
        return (0, claims_1.isSome)(this.defaulted.gender) ? this.gender() : undefined;
    }
    wireGivenName() {
        return (0, claims_1.isSome)(this.defaulted.givenName) ? this.givenName() : undefined;
    }
    wireLocale() {
        return (0, claims_1.isSome)(this.defaulted.locale) ? this.locale() : undefined;
    }
    wireMiddleName() {
        return (0, claims_1.isSome)(this.defaulted.middleName) ? this.middleName() : undefined;
    }
    wireName() {
        return (0, claims_1.isSome)(this.defaulted.name) ? this.name() : undefined;
    }
    wireNickname() {
        return (0, claims_1.isSome)(this.defaulted.nickname) ? this.nickname() : undefined;
    }
    wirePicture() {
        return (0, claims_1.isSome)(this.defaulted.picture) ? this.picture() : undefined;
    }
    wirePreferredUsername() {
        return (0, claims_1.isSome)(this.defaulted.preferredUsername)
            ? this.preferredUsername()
            : undefined;
    }
    wireProfile() {
        return (0, claims_1.isSome)(this.defaulted.profile) ? this.profile() : undefined;
    }
    wireUpdatedAt() {
        return (0, claims_1.isSome)(this.defaulted.updatedAt) ? this.updatedAt() : undefined;
    }
    wireWebsite() {
        return (0, claims_1.isSome)(this.defaulted.website) ? this.website() : undefined;
    }
    wireZoneinfo() {
        return (0, claims_1.isSome)(this.defaulted.zoneinfo) ? this.zoneinfo() : undefined;
    }
    wireEmailAlias() {
        return (0, claims_1.isSome)(this.defaulted.emailAlias) ? this.emailAlias() : undefined;
    }
    wireUserStatus() {
        return (0, claims_1.isSome)(this.defaulted.userStatus) ? this.userStatus() : undefined;
    }
    wirePhoneNumberAlias() {
        return (0, claims_1.isSome)(this.defaulted.phoneNumberAlias)
            ? this.phoneNumberAlias()
            : undefined;
    }
    errors() {
        return __classPrivateFieldGet(this, _CognitoClaimsImpl_ec, "f").errors;
    }
    isError() {
        return __classPrivateFieldGet(this, _CognitoClaimsImpl_ec, "f").isError();
    }
    lastError() {
        return __classPrivateFieldGet(this, _CognitoClaimsImpl_ec, "f").lastError();
    }
    toJSON() {
        return ToCognitoWireClaims(this.defaulted);
    }
    toParams() {
        const wc = this.toJSON();
        return {
            email: wc.email,
            phoneNumber: wc.phone_number,
            username: wc['cognito:username'],
            eventId: wc.event_id,
            isEmailVerified: wc.email_verified,
            isPhoneNumberVerified: wc.phone_number_verified,
            tokenUse: wc.token_use,
            address: wc.address,
            birthdate: wc.birthdate,
            familyName: wc.family_name,
            gender: wc.gender,
            givenName: wc.given_name,
            locale: wc.locale,
            middleName: wc.middle_name,
            name: wc.name,
            nickname: wc.nickname,
            picture: wc.picture,
            preferredUsername: wc.preferred_username,
            profile: wc.profile,
            updatedAt: wc.updated_at,
            website: wc.website,
            zoneinfo: wc.zoneinfo,
            emailAlias: wc['cognito:email_alias'],
            userStatus: wc['cognito:user_status'],
            phoneNumberAlias: wc['cognito:phone_number_alias'],
        };
    }
}
_CognitoClaimsImpl_ec = new WeakMap();
/**
 * @deprecated use TestCognitoClaims instead
 */
function DefaultCognitoClaims() {
    return TestCognitoClaims();
}
function TestCognitoClaims() {
    return {
        email: 'simple.email@test',
        phoneNumber: '+49110',
        username: 'simple.username',
        eventId: 'default-event-id',
        isEmailVerified: true,
        isPhoneNumberVerified: true,
        tokenUse: 'default-token-use',
        address: 'default-address',
        birthdate: 'default-birthdate',
        familyName: 'default-family-name',
        gender: 'default-gender',
        givenName: 'default-given-name',
        locale: 'default-locale',
        middleName: 'default-middle-name',
        name: 'default-name',
        nickname: 'default-nickname',
        picture: 'default-picture',
        preferredUsername: 'default-preferred-username',
        profile: 'default-profile',
        updatedAt: 'default-updated-at',
        website: 'default-website',
        zoneinfo: 'default-zoneinfo',
        emailAlias: 'default-email-alias',
        userStatus: 'default-user-status',
        phoneNumberAlias: 'default-phone-number-alias',
    };
}
class CognitoBuilder {
    constructor(claims) {
        _CognitoBuilder_claims.set(this, void 0);
        __classPrivateFieldSet(this, _CognitoBuilder_claims, claims, "f");
    }
    build() {
        return FromCognitoWireClaims({}, __classPrivateFieldGet(this, _CognitoBuilder_claims, "f"));
    }
    email(email) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").email = email;
        return this;
    }
    phoneNumber(phoneNumber) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").phoneNumber = phoneNumber;
        return this;
    }
    username(username) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").username = username;
        return this;
    }
    eventId(eventId) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").eventId = eventId;
        return this;
    }
    isEmailVerified(isEmailVerified) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").isEmailVerified = isEmailVerified;
        return this;
    }
    isPhoneNumberVerified(isPhoneNumberVerified) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").isPhoneNumberVerified = isPhoneNumberVerified;
        return this;
    }
    tokenUse(tokenUse) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").tokenUse = tokenUse;
        return this;
    }
    address(address) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").address = address;
        return this;
    }
    birthdate(birthdate) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").birthdate = birthdate;
        return this;
    }
    familyName(familyName) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").familyName = familyName;
        return this;
    }
    gender(gender) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").gender = gender;
        return this;
    }
    givenName(givenName) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").givenName = givenName;
        return this;
    }
    locale(locale) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").locale = locale;
        return this;
    }
    middleName(middleName) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").middleName = middleName;
        return this;
    }
    name(name) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").name = name;
        return this;
    }
    nickname(nickname) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").nickname = nickname;
        return this;
    }
    picture(picture) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").picture = picture;
        return this;
    }
    preferredUsername(preferredUsername) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").preferredUsername = preferredUsername;
        return this;
    }
    profile(profile) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").profile = profile;
        return this;
    }
    updatedAt(updatedAt) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").updatedAt = updatedAt;
        return this;
    }
    website(website) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").website = website;
        return this;
    }
    zoneinfo(zoneinfo) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").zoneinfo = zoneinfo;
        return this;
    }
    emailAlias(emailAlias) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").emailAlias = emailAlias;
        return this;
    }
    userStatus(userStatus) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").userStatus = userStatus;
        return this;
    }
    phoneNumberAlias(phoneNumberAlias) {
        __classPrivateFieldGet(this, _CognitoBuilder_claims, "f").phoneNumberAlias = phoneNumberAlias;
        return this;
    }
}
exports.CognitoBuilder = CognitoBuilder;
_CognitoBuilder_claims = new WeakMap();
//# sourceMappingURL=cognito-claims.js.map